import { isPrimitive } from "@agrigate/ts-utils/lib/validations";
import type { BoxProps, FlexProps } from "@chakra-ui/react";
import { Box, Flex, Heading, Spacer } from "@chakra-ui/react";
import type { PropsWithChildren, ReactElement, ReactNode } from "react";

const elevationShadowMap = {
    xs: "0px 1px 4px 0px rgba(0, 0, 0, 0.08)",

    // Update below when there is clarity on how to use variables like --contrast-20
    // in figma export
    s: "0px 1px 4px 0px rgba(0, 0, 0, 0.08)",
    m: "0px 1px 4px 0px rgba(0, 0, 0, 0.08)",
    l: "0px 1px 4px 0px rgba(0, 0, 0, 0.08)",
    xl: "0px 1px 4px 0px rgba(0, 0, 0, 0.08)",
    nn: undefined,
};

export interface ContentCardProps extends PropsWithChildren<BoxProps> {
    heading?: ReactNode;
    leftControls?: ReactNode;
    rightControls?: ReactNode;
    elevation?: keyof typeof elevationShadowMap;
    headerContainerProps?: FlexProps;
}

export default function ContentCard(p: ContentCardProps): ReactElement {
    let {
        heading,
        leftControls,
        rightControls,
        elevation,
        headerContainerProps,
        ...containerProps
    } = p;
    elevation ??= "xs";
    const shadow = elevationShadowMap[elevation];
    const hasHeading = !!(p.heading || p.rightControls || p.leftControls);

    return (
        <>
            {hasHeading ? (
                <Flex
                    direction="row"
                    alignItems="center"
                    {...headerContainerProps}
                >
                    {leftControls}
                    {isPrimitive(heading) ? (
                        <Heading size="sm">{heading}</Heading>
                    ) : (
                        heading
                    )}
                    <Spacer />
                    {rightControls}
                </Flex>
            ) : null}

            <Box
                background="white"
                boxShadow={shadow}
                p={4}
                borderRadius="4px"
                borderWidth="1px"
                borderColor="gray.100"
                {...containerProps}
            />
        </>
    );
}
